// cities

import List from '../../pages/Places/Beaches/List';
import Detail from '../../pages/Places/Beaches/Detail';
import Create from '../../pages/Places/Beaches/Create';

export const subRoutesBeaches = [
    {
        path: "",
        component: List,
        exact: true,
    }
].map((item) => {
    return {
        ...item,
        path: `/beaches/:type${item.path}`,
        private: true
    };
});

export const routesBeaches = [
    {
        path: "/create",
        component: Create,
        exact: true
    },
    {
        path: "/:elementId",
        component: Detail,
    }
].map((item) => {
    return {
        ...item,
        path: `/beaches/:type${item.path}`,
        private: true
    };
});